import gql from "graphql-tag";

export const RESOLVE_MODERATION_OPTION_MUTATION = gql`
  mutation ResolveModerationOption($input: ResolveModerationOptionInput!) {
    success: resolveModerationOption(input: $input)
  }
`;

export {
  ResolveModerationOption,
  ResolveModerationOptionVariables,
  ModerationOptionResolveAction,
  ResolveModerationOptionInput as IResolveModerationOptionInput
} from "~/graphql/types";



// WEBPACK FOOTER //
// ./src/graphql/mutations/optionRemoderation/resolveModerationOption.ts